import {
  Button,
  Card,
  Grid,
  Icon,
  List,
  Modal,
  NavBar,
  SearchBar,
  TabBar,
  Tabs,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
import MineList from "../mine";
import TestProject from "../XhomePage";
import HomePageList from "./shouye";
const HomePage = styled.div`
  .body {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
  }
  .TabBar {
    position: fixed;
    margin-bottom: 0px;
  }
`;
export default function IndexList() {
  const [state, setState] = useState<{
    selectedTab: string;
    hidden: boolean;
  }>({
    selectedTab: "redTab",
    hidden: false,
  });
  const history = useHistory();
  const tabs = [{ title: "通知" }, { title: "通告" }];
  return (
    <>
      <HomePage>
        <div className="body">
          <TabBar
            unselectedTintColor="#949494"
            tintColor="#33A3F4"
            barTintColor="white"
            // hidden={this.state.hidden}
            tabBarPosition="bottom"
          >
            <TabBar.Item
              title="首页"
              key="Life"
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(https://zos.alipayobjects.com/rmsportal/sifuoDUQdAFKAVcFGROC.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(https://zos.alipayobjects.com/rmsportal/iSrlOTqrKddqbOmlvUfq.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selected={state.selectedTab === "blueTab"}
              //   badge={1}
              onPress={() => {
                setState({
                  ...state,
                  selectedTab: "blueTab",
                });
              }}
              data-seed="logId"
            >
              <HomePageList />
            </TabBar.Item>
            <TabBar.Item
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(https://gw.alipayobjects.com/zos/rmsportal/BTSsmHkPsQSPTktcXyTV.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(https://gw.alipayobjects.com/zos/rmsportal/ekLecvKBnRazVLXbWOnE.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              title="应用"
              key="Koubei"
              //   badge={"new"}
              selected={state.selectedTab === "redTab"}
              onPress={() => {
                setState({
                  ...state,
                  selectedTab: "redTab",
                });
              }}
              data-seed="logId1"
            >
              <TestProject />
            </TabBar.Item>
            <TabBar.Item
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(https://zos.alipayobjects.com/rmsportal/psUFoAMjkCcjqtUCNPxB.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(https://zos.alipayobjects.com/rmsportal/IIRLrXXrFAhXVdhMWgUI.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              title="通讯录"
              key="Friend"
              //   dot
              selected={state.selectedTab === "greenTab"}
              onPress={() => {
                setState({
                  ...state,
                  selectedTab: "greenTab",
                });
              }}
            >
              通讯录
            </TabBar.Item>
            <TabBar.Item
              icon={{
                uri:
                  "https://zos.alipayobjects.com/rmsportal/asJMfBrNqpMMlVpeInPQ.svg",
              }}
              selectedIcon={{
                uri:
                  "https://zos.alipayobjects.com/rmsportal/gjpzzcrPMkhfEqgbYvmN.svg",
              }}
              title="我的"
              key="my"
              selected={state.selectedTab === "yellowTab"}
              onPress={() => {
                setState({
                  ...state,
                  selectedTab: "yellowTab",
                });
              }}
            >
              <MineList />
            </TabBar.Item>
          </TabBar>
        </div>
      </HomePage>
    </>
  );
}
